(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/constants.js');

const names = {
  REFERENCE: 'reference',
  ADDRESS: 'address1',
  ZIP: 'zip',
  CITY: 'city',
  COUNTRY: 'country',
  MESSAGE: 'message',
  ARTICLES: 'articles'
};

const FORMS = {
  HEADER: 'Beställ digitala lotter',
  ORDER_LABEL: 'Beställ',
  MINIMUM_AMOUNT: 1500,
  MINIMUM_AMOUNT_LOGGED_IN: 0,
  MINIMUM_AMOUNT_ERROR_MESSAGE: 'Minibelopp för första beställningen är 1 500 kr.',
  INVOICE_FORM: {
    REFERENCE: {
      REFERENCE_LABEL: 'REFERENS (PERSON, AVD, ETC)',
      REFERENCE_MAX: 35,
      REFERENCE_MAX_ERROR: 'Fältet får inte innehålla mer än 35 tecken',
      REFERENCE_REQUIRED_ERROR: 'Du måste ange en text'
    },
    CITY: {
      CITY_LABEL: 'POSTORT',
      CITY_MAX: 35,
      CITY_MAX_ERROR: 'Fältet får inte innehålla mer än 35 tecken',
      CITY_REQUIRED_ERROR: 'Du måste ange en text'
    },
    COUNTRY: {
      COUNTRY_LABEL: 'LAND',
      COUNTRY_REQUIRED_ERROR: 'Du måste ange en text'
    },
    MESSAGE: {
      MESSAGE_LABEL: 'EGET MEDDELANDE PÅ FAKTURAN (VALFRI)',
      MESSAGE_MAX: 500,
      MESSAGE_MAX_ERROR: ''
    }
  }
};

svs.ticket_partner.digitalTickets.constants = {
  FORMS,
  names
};


 })(window);